module.exports = __webpack_public_path__ + "img/java.7ecbf801.png";